/** Montants et dates selon la société courante. */
import { useMemo } from "react";
import { useCompany } from "../company/CompanyProvider";
import { formatCents, formatDay } from "./display";
import { formatsFromCompany } from "./types";

export function useFormatters() {
  const { company } = useCompany();
  const currency_display = company?.currency_display;
  const decimal_comma = company?.decimal_comma;
  const time_24h = company?.time_24h;
  const fiscal_year_start = company?.fiscal_year_start;
  return useMemo(() => {
    const formats = formatsFromCompany({
      currency_display,
      decimal_comma,
      time_24h,
      fiscal_year_start,
    });
    return {
      formats,
      money: (cents: number) => formatCents(cents, formats),
      day: (iso: string | null | undefined) => formatDay(iso, formats),
    };
  }, [currency_display, decimal_comma, time_24h, fiscal_year_start]);
}
